// API
import apibridge from '../apibridge';

// UTILS
import { validationErrorsToString } from '../utils';

// REDUX
import { store } from '../store';
import NotificationCountSlice from '../store/slices/NotificationCount';

export const useUpdateTotalNotification = async () => {
	const response = await apibridge.getNavigationActionTicker();

	response.result = response.result || 0;

	if (response.isError) {
		console.log(
			response.validationErrors.length ? validationErrorsToString(response.validationErrors) : response.message
		);
	} else {
		store.dispatch(
			NotificationCountSlice.actions.updateNotificationCount({
				totalCount: response.result
			})
		);
	}
};
